import "./tradingHeader.css";

import logo from "../../../assets/images/IPGlogo.png";
import Reveal from "../../utils/Reveal";
import About from "../About/About";
import Mission from "../Mission/Mission";

const TradingHeader = () => {
  return (
    <div className="trading-banner">
      <div className="container">
        <Reveal animationType="fadeInUp">
          <div className="row justify-content-center align-items-center trading-header pb-5 pt-3 align ">
            <div className="col-sm-12 col-md-6 col-lg-4 logo-img-wrapper">
              <img src={logo} alt="" className="logo-img"></img>
            </div>
            <div className="col-sm-12 col-md-6 col-lg-4">
              <h4 className="trading-title d-flex flex-column justify-content-center ">
                <span>CONSULTING</span>
                <span>AND BROKERS</span>
              </h4>
            </div>
          </div>
        </Reveal>
      </div>
      <About />
      <Mission />
    </div>
  );
};

export default TradingHeader;
